import { notification } from 'antd';

export async function copyToClipboard(value, label) {
  try {
    await navigator.clipboard.writeText(value);
    notification.success({ message: `Copied ${label}`, description: value, placement: 'bottomRight', duration: 3 });
  } catch {
    notification.error({ message: `Couldn't copy ${label}`, placement: 'bottomRight', duration: 3 });
  }
}
